import { HStack, Icon, Square, Text } from '@chakra-ui/react';
import { IoIosWarning } from 'react-icons/io';

import { InfoCard } from '../components/InfoCard';
import LanguageSwitch from '../components/LanguageSwitch';
import VersionHint from '../pages/VersionHint';

export const DebuggingBanner = () => {
  return (
    <InfoCard>
      <HStack>
        <Square size="10" borderRadius="md" display={'inline'}>
          <Icon color={'orange'} as={IoIosWarning} boxSize="8" />
        </Square>
        <Text>You are in a test environment</Text>
      </HStack>

      <LanguageSwitch />
      <VersionHint />
    </InfoCard>
  );
};
